import React from 'react';
import { Carousel, CarouselNavigation, CarouselSlide, CarouselWrapper } from '$partials/base/carousel';
import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').FeaturedArticlesCarousel}
 */
const FeaturedArticlesCarousel = ({
    title,
    items,
    listing
}) => {
    return (
        <Carousel swiperConfig={{
            slidesPerView: 'auto',
            spaceBetween: 2,
            breakpoints: {
                640: {
                    slidesPerView: 'auto',
                    spaceBetween: 2
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 2
                }
            },
        }}>
            <div className='overflow-hidden container featured-articles-carousel-container overhang-left sm-overhang-left-0 md-overhang-left-0'>
                <div className='col-12 flex items-center justify-between px5 md-px6 py5 md-py7 border-bottom grey bg-sand'>
                    <h2 className='type-style-2 black'>{title}</h2>

                    <div className='flex flex-row items-center'>
                        {listing &&
                                <a
                                    className='type-style-5 md-mr6 black link'
                                    href={listing.url}>
                                    View All
                                </a>
                        }

                        <div className='hide md-show'>
                            <CarouselNavigation look='row'/>
                        </div>
                    </div>
                </div>

                <CarouselWrapper className='swiper-wrapper'>
                    {items?.map((item, i) => {
                        const page = item.page;

                        if (!page) { return null; }

                        const author = page?.author;
                        const categories = page?.categories;

                        return (
                            <CarouselSlide
                                className='flex carousel-slide'
                                index={i}
                                key={`featured-article-${page?.id}-${i}`}>
                                <a
                                    className='link-reset flex'
                                    href={page?.url}>
                                    <div
                                        className='flex flex-col bg-sand px5 md-px6 pt5 pb6 md-pt8 md-pb9 border-top grey  carousel-item-fixed-height justify-between'>
                                        <div
                                            className='flex flex-wrap'
                                            style={{
                                                width: `${(page?.listingImage?.width / page?.listingImage?.height)}em`
                                            }}>
                                            {categories?.map((category, idx) => {
                                                return(<p
                                                    className='type-style-5 black inline-block mr2'
                                                    key={`featured-article-category-${category?.id}`}>{category?.label}{categories?.length > 1 && idx !== categories?.length -1 ? ', ' : ''}</p>);
                                            })}
                                            <div className='min-height-90px block width-100'>
                                                <h3 className='type-style-3 sans-serif black width-100'>
                                                    {page?.title}
                                                </h3>
                                            </div>
                                        </div>
                                        <div
                                            className='pt5'>
                                            <div
                                                className='carousel-item-height'
                                                style={{
                                                    width: `${(page?.listingImage?.width / page?.listingImage?.height)}em`
                                                }}>
                                                <Image {...page?.listingImage}/>
                                            </div>
                                            <div className='mt5 md-mt4 flex min-height-22px'>
                                                <p className='type-style-5 black inline'>{author ? `Words by ${author}` : ' '}</p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </CarouselSlide>
                        );
                    })}
                </CarouselWrapper>
            </div>
        </Carousel>

    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default FeaturedArticlesCarousel;
